import { User } from '@/types/tower/v2/User';
import { Program } from '@/types/tower/v2/Program';
import { LocationQueryRaw } from 'vue-router';

export const BOUND_COVERAGE_TOOLTIP =
  'Bound Coverage Towers source data from Epic to populate carriers, premiums, and limit information. These towers can be used to visualize current or expired coverage';
export const NEW_COVERAGE_TOOLTIP =
  'Use New Coverage Towers to display potential insurance coverage for a client. These towers can be used when creating RFP materials or cross-selling a new line of business to an existing client';
export const RENEWAL_TOOLTIP =
  'Use Renewal Towers to copy a client’s current coverage details (Carriers, Limits, etc.) and tower visuals if available. These towers are useful before binding a renewal to display potential changes to the program';
export const SCRATCH_TOOLTIP =
  'Use Scratch Towers to experiment with the Tower Builder or create visuals for potential clients that are not on the Platform. These towers are not associated with and will not be visible to clients';

export interface TowerCardData {
  towerId: string;
  towerTypeId: number;
  towerName?: string;
  accountName?: string;
  accountId?: number;
  createdOn: string; // ISO Date string
  updatedOn: string; // ISO Date string
  version: number;
  versionLabel?: string;
  loadError: boolean;
  published: boolean;
  program: Program;
  user: User;
  contributors: string;
  towerCards?: TowerCardData[]; // Only for TowerType.MultiTower, this represents the list of towers in the multi-tower
}

export enum TowerType {
  BoundCoverage = 1,
  NewCoverage = 2,
  Renewal = 3,
  Scratch = 4,
  MultiTower = 5,
}

export interface TowerTypeData {
  id: number;
  name: string;
}

export interface TowerDashboardRouteQuery extends LocationQueryRaw {
  q?: string;
  ownership?: string;
  type?: string;
}
